import { useEffect, useCallback } from 'react';
import { useSocket } from '~/context/socket';
import socketEvent from '~/constants/socketEvent';
import { Socket } from 'socket.io-client';


export const useSocketOn = (eventName: string, eventHandler: (...args: any[]) => void, condition?: () => boolean) => {

  const { socket } = useSocket();

  const isEnabled = useCallback(() => !condition || condition(), [condition]);

  useEffect(() => {
    if (!socket) return;
    const socketInstance = socket as Socket;
    const enabled = isEnabled();
    if (enabled) {
      socketInstance.on(eventName, eventHandler);
    }
    return () => {
      if (enabled && socket) {
        socketInstance.off(eventName, eventHandler);
      }
    }
  }, [eventName, eventHandler, isEnabled, socket]);
}

export const useSubscribeToUser = (id: number | null | undefined, condition?: () => boolean) => {

  const { socket } = useSocket();

  const isEnabled = useCallback(() => !condition || condition(), [condition]);

  useEffect(() => {
    if (!socket) return;
    const socketInstance = socket as Socket;
    const enabled = isEnabled();
    if (enabled && socketInstance.connected && !!id) {
      socketInstance.emit(socketEvent.subscribeToUser, { id });
    }
    return () => {
      if (enabled && socket && socketInstance.connected && !!id) {
        socketInstance.emit(socketEvent.unsubscribeFromUser, { id });
      }
    }
  }, [id, isEnabled, socket]);
}

export const useSubscribeToOrderSigner = (id: number | null | undefined, condition?: () => boolean) => {

  const { socket } = useSocket();

  const isEnabled = useCallback(() => !condition || condition(), [condition]);

  useEffect(() => {
    if (!socket) return;
    const socketInstance = socket as Socket;
    const enabled = isEnabled();
    if (enabled && socketInstance.connected && !!id) {
      socketInstance.emit(socketEvent.subscribeToOrderSigner, { id });
    }
    return () => {
      if (enabled && socket && socketInstance.connected && !!id) {
        socketInstance.emit(socketEvent.unsubscribeFromOrderSigner, { id });
      }
    }
  }, [id, isEnabled, socket]);
}

export const useSubscribeToOrderMessages = () => {

  const { socket } = useSocket();

  useEffect(() => {
    if (!socket) return;
    const socketInstance = socket as Socket;
    if (socketInstance.connected) {
      socketInstance.emit(socketEvent.subscribeToOrderMessages);
    }
    return () => {
      if (socket && socketInstance.connected) {
        socketInstance.emit(socketEvent.unsubscribeFromOrderMessages);
      }
    }
  }, [socket]);
}
